import { useLayoutEffect, useRef, useState } from 'react';
import MuiStaticDatePicker, {
  StaticDatePickerProps as MuiStaticDatePickerProps,
} from '@mui/lab/StaticDatePicker';

import { CalendarContainer } from './StaticDatePicker.styled';

interface StaticDatePickerProps extends MuiStaticDatePickerProps {
  isSmall?: boolean;
}

function StaticDatePicker({ isSmall = false, ...rest }: StaticDatePickerProps) {
  const containerRef = useRef<HTMLElement>(null);
  const [, forceRender] = useState<undefined | {}>();

  const onHandleViewChanged = (): void => {
    forceRender({});
  };

  useLayoutEffect(() => {
    const dateOptionsContainer = containerRef.current?.querySelector<HTMLElement>(
      '.MuiCalendarPicker-viewTransitionContainer',
    );
    if (dateOptionsContainer) {
      const selected = dateOptionsContainer.querySelector<HTMLElement>('.Mui-selected');
      dateOptionsContainer.scrollTop = selected?.offsetTop ?? 0;
    }
  });

  return (
    <CalendarContainer isSmall={isSmall} ref={containerRef}>
      <MuiStaticDatePicker onViewChange={onHandleViewChanged} {...rest} />
    </CalendarContainer>
  );
}

export { StaticDatePickerProps, StaticDatePicker };
export default StaticDatePicker;
